import React, { useCallback, useMemo, useEffect, useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from '../../../localization/useTranslation';
import { splitBaseRestUrl } from '../../NodePage/location';
import _ from 'lodash';


import Tl from '../../../localization/LocalizationKeys';
import SimpleTable, { createDefaultActions, SortDirection } from '../../Common/SimpleTable/SimpleTable';
import useApiCall from '../../../services/useApiCall';
import useAPI from '../../../services/useAPI';
import DeleteAlarm from './DeleteAlarm';
import ContentPage from '../../ContentView/ContentPage/ContentPage';
import AlertContext from 'services/AlertContext';

const columns = [
  {
    label: Tl.common.name,
    path: 'name',
    isSortable: true,
    searchItem: true
  },
  {
    label: Tl.common.description,
    path: 'description',
    isSortable: true,
    searchItem: true
  }
];

const DefaultSortBy = {
  path: 'name',
  direction: SortDirection.DESC
};


const AlarmDefinitionsList = ({ breadcrumbs }) => {
  const api = useAPI();
  const { addErrorAlert } = useContext(AlertContext);
  const T = useTranslation();

  const [alarmDefinitions, setAlarmDefinitions] = useState();

  const history = useHistory();
  const location = useLocation();
  const [baseUrl, setBaseUrl] = useState('');

  const [confirmDeleteItem, setConfirmDeleteItem] = useState(null);
  const onDelete = useCallback(definition => setConfirmDeleteItem(definition), []);
  const actions = useMemo(() => createDefaultActions({ onDelete }), [onDelete]);


  useEffect(() => {
    const [base] = splitBaseRestUrl(location.pathname);
    setBaseUrl(base);
  }, [location.pathname]);

  const [getAlarmDefs, isLoadingDefs] = useApiCall({
    apiCall: api.core.getAlarms,
    onSuccess: useCallback((defs) => {
      setAlarmDefinitions(defs);
    }, []),
    onError: useCallback(() => {
      addErrorAlert('failed to load alarm definitions');
    }, [addErrorAlert])
  });

  useEffect(() => {
    getAlarmDefs();
  }, [getAlarmDefs]);

  const createNewAlarmDefinition = useCallback(() => {
    history.push(`${baseUrl}/new-def`);
  }, [baseUrl, history]);

  const onRowClick = useCallback((alarmDef) => {
    history.push({
      pathname: `${baseUrl}/${alarmDef.id}`
    });
  }, [baseUrl, history]);

  const onDeletedAlarm = useCallback((alarm) => {
    setAlarmDefinitions(oldDefinitions => {
      return _.reject(oldDefinitions, { id: alarm.id });
    });
    setConfirmDeleteItem(null);
  }, []);
  return (
    <ContentPage breadcrumb={breadcrumbs} help={'admin/alarms/list'}>
      <SimpleTable
        actions={actions}
        isLoading={isLoadingDefs}
        onRowClick={onRowClick}
        data={alarmDefinitions}
        columns={columns}
        sortBy={DefaultSortBy}
        errorText={T.admin.trees.error.failedload}
        globalActions={[{ onClick: createNewAlarmDefinition }]}
        compact
        usePaging
      />
      <DeleteAlarm
        confirmDeleteItem={confirmDeleteItem}
        onDelete={onDeletedAlarm}
        onCancel={() => {
          setConfirmDeleteItem(null);
        }}
      />
    </ContentPage>
  );
};

export default AlarmDefinitionsList;
